/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Box, Text, rem } from '@mantine/core';

import { useLocale } from 'next-intl';
import React from 'react';
import { LabelType, type ProgressesSubscriptionData } from '../../api';

type ProgressesStatusProps = {
  label: ProgressesSubscriptionData['label'];
};

export default function ProgressesStatus({ label }: ProgressesStatusProps) {
  const locale = useLocale();

  const labelArr = [
    {
      label: {
        type: LabelType.ACTIVE,
      },
      color: 'green.4',
    },
    {
      label: {
        type: LabelType.EXPIRES_SOON,
      },
      color: 'red.6',
    },
    {
      label: {
        type: LabelType.USED,
      },
      color: 'neutral.4',
    },
  ];

  const colorOfLabel =
    labelArr.find((item) => item.label.type === label.type)?.color ||
    'neutral.4';

  return (
    <Box
      pos="relative"
      bg={colorOfLabel}
      c="white"
      w="fit-content"
      p={rem(4)}
      style={{
        borderRadius: '4px 4px 0 4px',
      }}
    >
      <Text size="sm" fw={600} lh={rem(20)}>
        {label[locale]}
      </Text>
      <Box
        className="triangle"
        pos="absolute"
        top="100%"
        right={0}
        style={{
          width: 0,
          height: 0,
          borderBottom: '5px solid transparent',
          borderRight: '0 solid transparent',

          borderLeft: '5px solid #012749',
        }}
      />
    </Box>
  );
}
